import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useLayoutEffect, useState } from 'react';

import { useQueryConfiguracoes } from 'pages/financeiro/dre/configuracao/hooks';
import { DreConfiguracao } from 'pages/financeiro/dre/configuracao/types';
import { getColorById } from 'pages/financeiro/dre/configuracao/utils';

export type DreConfigConfiguracoesContext = {
    configuracoes: DreConfiguracao[];
    setConfiguracoes: Dispatch<SetStateAction<DreConfiguracao[]>>;

    isFetchingConfiguracoes: boolean;
};

const DreConfigConfiguracoesContext = createContext<DreConfigConfiguracoesContext>({} as DreConfigConfiguracoesContext);

export function DreConfigConfiguracoesProvider({ children }: { children?: ReactNode }) {
    const [configuracoes, setConfiguracoes] = useState<DreConfiguracao[]>([]);
    const { data: configuracoesData, isFetching: isFetchingConfiguracoes } = useQueryConfiguracoes();

    useLayoutEffect(() => {
        if (configuracoesData) {
            const coloredConfiguracoes = configuracoesData.map((configuracao) => ({
                ...configuracao,
                color: getColorById(configuracao.idDreMercadologicaConfiguracao),
            }));

            setConfiguracoes(coloredConfiguracoes);
        }
    }, [configuracoesData]);

    return (
        <DreConfigConfiguracoesContext.Provider
            value={{
                isFetchingConfiguracoes,
                configuracoes,
                setConfiguracoes,
            }}
        >
            {children}
        </DreConfigConfiguracoesContext.Provider>
    );
}

export const useDreConfigConfiguracoesContext = (): DreConfigConfiguracoesContext => useContext(DreConfigConfiguracoesContext);
